import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  Paper,
  Button,
  CircularProgress,
} from "@mui/material";
import { useNavigate, useParams } from "react-router";
import { get, post } from "src/services/httpClient.service";
import { authenticationService } from "src/services/authentication.service";

import PermissionTable from "./PermissionTable";
import qs from "qs";
import { useSnackbar } from "src/components/snackbar/useSnackbar";

const MenusRole = () => {
  const API_URL = process.env.REACT_APP_BASE_API_URL;
  const { showSnackbar } = useSnackbar();
  const { vendorId, franchiseId } = authenticationService.getVendorFranchiseIds() || {};
  const navigate = useNavigate();
  const { roleId, menuId } = useParams();

  const [search, setSearch] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);
  const [modules, setModules] = useState([]);
  const [groupedModules, setGroupedModules] = useState([]);
  const [checkrights,setCheckrights] = useState<any>()
  const [selectedPermission, setSelectedPermission] = useState([]); // stores modPermissionId values

  const checktightsfun = () =>{
    console.log("menuId---"+menuId)
    if(menuId === 'right'){
       setCheckrights(false)
    }else{
      setCheckrights(true)
    }
  }

  useEffect(()=>{
  checktightsfun();
  },[menuId])

  const safeGet = async (url, params) => {
    try {
      const response = await get(url, params);
      return response?.data || [];
    } catch (err) {
      console.error("API error:", url, err);
      return [];
    }
  };

  const transformModulePermissions = (data, selectedPermission = []) => {
    if (!Array.isArray(data)) return [];

    // ✅ selectedPermission is already a list of permission IDs
    const selectedIds = new Set(selectedPermission);

    const map = new Map();
    data.forEach((item) => {
      const moduleId = item?.appModule?.id;
      const moduleName = item?.appModule?.name || "Unknown Module";
      if (!moduleId) return;

      if (!map.has(moduleId)) {
        map.set(moduleId, { id: moduleId, name: moduleName, permissions: [] });
      }

      if (item?.id && item?.name) {
        map.get(moduleId).permissions.push({
          id: item.id,
          name: item.name,
          displayName: item.displayName || item.name,
          selected: selectedIds.has(item.id), // ✅ default checked status
        });
      }
    });

    return Array.from(map.values());
  };

  // Load data in correct order
  useEffect(() => {
    //http://localhost:8081/api/globalRole/tenant/bnhgdk0-mjuy9as-lkjtrweq9/subscription/jhuyi9-kjluei0-khdue9/findById?roleId=7b3d1925-069b-4be3-a072-54cf733f4b93
    // Fetch role permissions for one or more roleIds
    const loadData = async () => {
      try {
        const moduleData = await safeGet(
          `${API_URL}/api/modulepermission/vendor/${vendorId}/franchise/${franchiseId}/findAll`,
          null
        );
        setModules(moduleData);
        let rolePermissionData = null;
        console.log("checkrights:::"+checkrights)
        if(menuId==='right') {
           // ✅ Pass multiple roleIds as array
          const roleIdsToFetch = [roleId]; // in future, can push more roleIds here
          rolePermissionData = await safeGet(
          `${API_URL}/api/rolepermission/vendor/${vendorId}/franchise/${franchiseId}/getAllRolesByOperatorId`,
          {
            params: { operatorId: roleId }
          });
        } else {
           // ✅ Pass multiple roleIds as array
          rolePermissionData = await safeGet(
          `${API_URL}/api/rolepermission/vendor/${vendorId}/franchise/${franchiseId}/getAllRolesByRoleIds`,
          {
            params: { roleIds: [roleId] },
            paramsSerializer: params => {
              return qs.stringify(params, { arrayFormat: "repeat" }); 
              // This produces: roleIds=role1&roleIds=role2
            }
          });
        }
       
      

        const selected = rolePermissionData?.map((item) => item.modPermissionId) || [];
        setSelectedPermission(selected);

        setGroupedModules(transformModulePermissions(moduleData, selected));
      } catch (err) {
        console.error("Error loading modules/permissions:", err);
      }
    };


    loadData();
  }, [roleId, menuId]);

  const saveRolePermissions = async () => {
    setSaveLoading(true);
    try {
      const payload = selectedPermission.map((id) => ({
        roleId,
        modPermissionId: id,
        vendorId,
        franchiseId,
        createdByUser: "",
        createdBy: "",
      }));

      await post(`${API_URL}/api/rolepermission/bulk/`, payload);
      showSnackbar("✅ Role permissions saved successfully",'success');
      navigate("/Role/role")
    } catch (error) {
      console.error("Save error:", error);
      alert("❌ Failed to save permissions");
    }
    setSaveLoading(false);
  };

  const saveuserrights = async () => {

   

   /*  setSaveLoading(true);
    try {
      const payload = selectedPermission.map((id) => ({
        roleId,
        modPermissionId: id,
        vendorId,
        franchiseId,
        createdByUser: "",
        createdBy: "",
      }));

      await post(`${API_URL}/api/rolepermission/bulk/`, payload);
      showSnackbar("✅ Role permissions saved successfully",'success');
      navigate("/Role/role")
    } catch (error) {
      console.error("Save error:", error);
      alert("❌ Failed to save permissions");
    }
    setSaveLoading(false); */

    navigate("/Operator/operator")

  }

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
         ⚙️{!menuId?  'Manage Role Permissions':'Manage User Rights' }
        </Typography>

        <TextField
          size="small"
          placeholder="Search modules..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ width: 250 }}
        />
      </Box>

      {groupedModules.length > 0 ? (
        <PermissionTable
          groupedModules={groupedModules}
          onSelectionChange={setSelectedPermission}
        />
      ) : (
        <Typography sx={{ mt: 2 }}>Loading...</Typography>
      )}

      <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}>
        <Button variant="contained" onClick={!menuId?() => navigate("/Role/role"):() => navigate("/Operator/operator")}>
          Cancel
        </Button>
       {!menuId? <Button
          variant="contained"
          disabled={saveLoading}
          startIcon={saveLoading ? <CircularProgress size={20} /> : null}
          onClick={saveRolePermissions}
        >
          {saveLoading ? "Saving..." : "Save Permissions"}
        </Button>:
         <Button
          variant="contained"
          disabled={saveLoading}
          startIcon={saveLoading ? <CircularProgress size={20} /> : null}
          onClick={saveuserrights}
        >
          {saveLoading ? "Saving..." : "Save rights"}
        </Button>
        }
      </Box>
    </Box>
  );
};

export default MenusRole;
